import apiClient from './config';

export interface AuditLog {
    _id: string;
    actor: { userId: string | null; email: string | null; role: string | null };
    action: string;
    targetType: string | null;
    targetId: string | null;
    targetLabel: string | null;
    metadata?: Record<string, unknown>;
    tenantCode: string;
    createdAt: string;
}

export interface AuditLogQuery {
    action?: string;
    targetType?: string;
    actorUserId?: string;
    from?: string;
    to?: string;
    q?: string;
    page?: number;
    limit?: number;
}

export interface AuditLogPage {
    items: AuditLog[];
    total: number;
    page: number;
    limit: number;
    pages: number;
}

export const fetchAuditLogs = async (params: AuditLogQuery = {}): Promise<AuditLogPage> => {
    const response = await apiClient.get('/audit-logs', { params });
    return response.data;
};

export const fetchAuditFilters = async (): Promise<{ actions: string[]; targetTypes: string[] }> => {
    const response = await apiClient.get('/audit-logs/actions');
    return response.data;
};
